<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetObjectList' }">预算对象</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="editDetails(3)">新增</el-button>
                    <el-button size="small" plain @click="editDetails(5)">复制</el-button>
                    <el-button size="small" plain @click="editDetails(1)">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="code：">
                                    <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"><el-form-item label="所有人："> </el-form-item> </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="名称：">
                                    <el-input v-model="list.name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="全名称：">
                                    <div class="read_only">
                                        <span>{{ list.full_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="标签：">
                                    <div class="read_only">
                                        <span>{{ list.label }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="全标签：">
                                    <div class="read_only">
                                        <span>{{ list.full_label }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="对象上级：">
                                    <div class="read_only read_only_link">
                                        <span v-if="list.parent" @click="mainClick(list.parent_rid)">{{ list.parent.name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="全路径：">
                                    <div class="read_only">
                                        <span>{{ list.full_rid }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><div class="space"></div>
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="预算子对象" name="2">
                    <!-- 预算子对象列表 -->
                    <vBudgetObjectList :postList="postList" v-if="flag"></vBudgetObjectList>
                </el-collapse-item>
                <el-collapse-item disabled title="预算科目" name="2">
                    <!-- 预算科目列表 -->
                    <vBudgetAccountList-component :postList="postList2" v-if="flag2"></vBudgetAccountList-component>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vBudgetObjectList from '../../listComponent/budget/budgetObjectList/budgetObjectListComponent.vue';
import vBudgetAccountListComponent from '../../listComponent/budget/budgetAccountList/budgetAccountListComponent.vue';
export default {
    inject: ['reload'],
    name: 'bludgetObjecDetails',
    components: {
        vBudgetObjectList,
        vBudgetAccountListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: false,
                name: false,
                full_name_rid: false,
                full_label_rid: false,
                parent_rid: false,
                addBtn: false,
                searchBtn: false,
                resetBtn: false,
                downFileBtn: false,
                setBtn: true,
                updateBtn: false,
                params: {
                    parent_rid: ''
                }
            },
            flag: false,
            postList2: {
                headerTitle: false,
                code: false,
                name: false,
                remark: false,
                label: false,
                type: false,
                principal_rid: false,
                assistance: false,
                accounting_attribute: false,
                status: false,
                department_rid: false,
                budget_object_rid: false,
                addBtn: false,
                searchBtn: false,
                resetBtn: false,
                downFileBtn: false,
                setBtn: true,
                params: {
                    budget_object_rid: ''
                }
            },
            flag2: false,
            headerTitle: '预算对象详情',
            list: {},
            activeNames: ['1', '2'],
            rid: ''
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.postList.params.parent_rid = to.query.id;
            this.postList2.params.budget_object_rid = to.query.id;
            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.postList.params.parent_rid = this.$route.query.id;
        this.postList2.params.budget_object_rid = this.$route.query.id;
        this.getDetails(); //获取详情
        this.flag = false;
        this.flag2 = false;
        this.$nextTick(() => {
            this.flag = true;
            this.flag2 = true;
        });
    },
    methods: {
        //上级对象查看
        mainClick(rid) {
            this.postList.params.parent_rid = rid;
            this.postList2.params.budget_object_rid = rid;
            this.$router.push({
                path: 'budgetObjectDetails',
                query: {
                    id: rid
                }
            });
        },
        //删除当前详情
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetObjectDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/budgetObjectList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails(type) {
            this.$router.push({
                path: 'budgetObjectEdit',
                query: {
                    type: type,
                    id: this.rid
                }
            });
        },
        //前往编辑页面 在子对象上新增 携带上级id参数跳转
        editItemDetails(id, type) {
            this.$router.push({
                path: 'budgetObjectEdit',
                query: {
                    type: type,
                    id: id
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetObjectList' });
            } else {
                this.$router.go(-1);
            }
        },
        //详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetObjectDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>